import { useCallback } from 'react';
import { pruneNilValues } from '@core/object';
import { appContextToTrackingDataPixel, sendPixelTrackingWithSession, } from '@core/tracking';
import { getVideoPlayId } from '@core/tracking/videoPlayIdTracking';
import { PlaySourceEnum } from '@embed/constants';
import { useStoreApi } from '../store';
import { ENGAGEMENT_INTERACTABLE_VIEW } from './endpoints/engagement';
/**
 * Tracks when a user has engaged with a video in the embed feed.
 */
export function useTrackEmbedEngagedVideo() {
    const store = useStoreApi();
    return useCallback((appContext, engagedVideoId, endpoint = ENGAGEMENT_INTERACTABLE_VIEW) => {
        const { params } = store.getState();
        const pixelTrackingData = appContextToTrackingDataPixel({ appContext });
        const widgetId = params?.widget_id ?? '';
        const videoPlayId = getVideoPlayId(widgetId, engagedVideoId ?? '', PlaySourceEnum.AUTOPLAY);
        const pixelData = {
            event_properties: pruneNilValues({
                _video_id: engagedVideoId,
                video_play_id: videoPlayId,
                ...pixelTrackingData,
            }),
        };
        sendPixelTrackingWithSession({
            endpoint,
            data: pixelData,
            host: params.api_host_tracking,
        });
    }, [store]);
}
